// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Local Imports
import endPoints from '@/redux/constant';
import axios from '@/redux/http';
import { PURGE } from 'redux-persist';

// Initial State
const initialState = {
  loading: false,
  error: null,
  newUser : null,
};

// Login User API Fn
export const generateMediakitAPIFn = createAsyncThunk(
  'auth/generateMediakit',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.login, {
        ...values,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);


// Generate MediaKit Slice
export const generateMediakitSlice = createSlice({
  name: 'generateMediaKit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generateMediakitAPIFn.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.newUser = null;
      })
      .addCase(generateMediakitAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.newUser = action.payload;
        state.error = null;
      })
      .addCase(generateMediakitAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.newUser = null;
      })
      .addCase(PURGE, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export default generateMediakitSlice.reducer;